export default {
  getList: (specifiedKey) => ['app-instance-list-' + specifiedKey],
};
